import { Component, OnInit, Input, Output, EventEmitter, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { IngredientChoice, OrderedItem, OrderedItemService, IngredientChoicesType } from 'ngx-web-api';
import { IngredientSelection } from '../../domain/ingredient-selection';
import { StageIngredientAction } from '../../item-editor/domain/stage-ingredient-action.model';
import { ViewportService } from 'app/core/services/viewport.service';
import { map, distinctUntilChanged } from 'rxjs/operators';
import { ViewPort } from 'app/domain/view-port.model';

@Component({
  selector: 'fts-pills-choices',
  templateUrl: 'pills-choices.component.html',
  styleUrls: ['pills-choices.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PillsChoicesComponent implements OnInit, OnChanges {
  @Input()
  choices: IngredientChoice[] = [];
  @Input()
  selectedChoice: IngredientChoice;
  @Input()
  item: OrderedItem;
  @Input()
  caloriesDisclaimer: string;
  @Input()
  ignoreIngredientGroups: boolean;
  @Input()
  hasGraphicalBuilder: boolean;
  @Input()
  smallPills: boolean;
  @Input()
  hideSinglePill: boolean;
  @Input()
  inModal: boolean;
  @Input()
  capitalize: boolean;
  @Input()
  ingredientChoicesType: string;
  @Input()
  itemHasGroupChoices = false;
  @Input()
  hasChoiceGroups: boolean;
  @Input()
  inItemEditorModal = false;
  @Input()
  isHalfAndHalf = false;

  @Output()
  choiceChange = new EventEmitter<IngredientChoice>();
  @Output()
  halfSelectionChange = new EventEmitter<IngredientSelection>();
  @Output()
  qualifierSelectionChange = new EventEmitter<IngredientSelection>();
  @Output()
  ingredientSelectionsChange = new EventEmitter<IngredientSelection[]>();
  @Output()
  stageActionChange: EventEmitter<StageIngredientAction> = new EventEmitter();

  ingredientChoicesTypeEnum = IngredientChoicesType;
  hasDependingIngredient: boolean;
  needsOverlay = false;
  isMobile = false;

  constructor(private orderedItemService: OrderedItemService, public viewportService: ViewportService) {}

  ngOnInit() {
    this.viewportService.viewport$
      .pipe(
        map((viewport: ViewPort) => viewport.isMobile),
        distinctUntilChanged()
      )
      .subscribe((isMobile: boolean) => {
        this.isMobile = isMobile;
        this.needsOverlay = this.ingredientChoicesType === this.ingredientChoicesTypeEnum.Pills && this.isMobile;
      });
  }

  ngOnChanges(changes) {
    if (changes['item'] && !!this.selectedChoice) {
      this.hasDependingIngredient = this.orderedItemService.hasDependencyMet(this.item, this.selectedChoice);
    }
    if (changes['ingredientChoicesType']) {
      this.needsOverlay = changes['ingredientChoicesType'].currentValue === this.ingredientChoicesTypeEnum.Pills && this.isMobile;
    }
  }

  onChoiceChange(choice: IngredientChoice, event: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    this.choiceChange.emit(choice);
  }

  onHalfSelectionChange(ingredientSelection: IngredientSelection) {
    this.halfSelectionChange.emit(ingredientSelection);
  }

  onQualifierSelectionChange(ingredientSelection: IngredientSelection) {
    this.qualifierSelectionChange.emit(ingredientSelection);
  }

  onIngredientSelectionsChange(selections: IngredientSelection[]) {
    this.ingredientSelectionsChange.emit(selections);
  }

  onStageActionChange(stageAction: StageIngredientAction) {
    this.stageActionChange.emit(stageAction);
  }
}
